export default __webpack_public_path__ + "static/media/whereFind.9164a240.svg";